import type { ReactNode } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { HelpIconButton } from '@components/HelpIconButton';

type Props = {
    title: ReactNode;
};

export const HelpAdornment = ({ title }: Props) => (
    <InputAdornment position="end">
        <HelpIconButton title={title} />
    </InputAdornment>
);
